var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pdf"}},[_c('iframe',{attrs:{"width":"100%","height":"900px","frameborder":"0","src":"AppTerms.pdf"}})])
}]

export { render, staticRenderFns }